import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { fetchEventSource } from '@microsoft/fetch-event-source';

import useApi from '../actions/useApi';
import { API_BASE_URL } from '../apiUtils';
import { useStateContext } from '../store/stateContext';

let initialized = false;

const useSSE = () => {
  const { state } = useStateContext();
  const {
    getWidgetInfo
  } = useApi();
  const scriptTag = document.getElementById('widget_loader');
  const widgetId = scriptTag?.getAttribute('data-widget-id');
  const handleMessageEvent = (event: any) => {
    console.log({ event });
    
    switch (event?.event) {
      case 'refresh data':{
        const data = JSON.parse(event.data);
        const ogUrlMetaTag = document.querySelector('meta[property="og:url"]');
        const ogUrl = ogUrlMetaTag ? ogUrlMetaTag.getAttribute('content') : null;
        console.log('refresh', data, state, {url: ogUrl});
        getWidgetInfo(widgetId as string, ogUrl as string);
        break;
      }
      default:
        console.log(event);
    }
  };
  const connectToSSE = async (controller: AbortController) => {
    console.log('Connecting to SSE api call');
    await fetchEventSource(`${API_BASE_URL}/sse/subscribe`, {
      openWhenHidden: true,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        sse_id: uuidv4(),
      }),
      signal: controller.signal,
      onopen(res: Response): any {
        if (res.ok && res.status === 200) {
          console.log('Connection made ', res);
        } else if (
          res.status >= 400 &&
          res.status < 500 &&
          res.status !== 429
        ) {
          console.log('Client side error ', res);
        }
      },
      onmessage(event: any) {
        handleMessageEvent(event);
      },
      onclose() {
        console.log('Connection closed by the server');
        initialized = false;
      },
      onerror(err: any) {
        console.log('There was an error from server', err);
      },
    });
  };
//   useEffect(() => {
//     if (networkStatus === NetworkStatus.OFFLINE) {
//       //TODO This is not working re-check
//       controller.abort();
//       initialized = false;
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [networkStatus]);
  useEffect(() => {
    if (!initialized) {
      const controller = new AbortController();
      connectToSSE(controller);
      initialized = true; // To avoid re-initialization once connected
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
};

export default useSSE;
